import { IInitialState } from "./types";

export const initialState: IInitialState = {
  marathonParticipantImageByFileId: {
    params: {
      fileId: null,
    },
    response: {
      data: null as string | null,
      loading: false,
      error: null,
    }
  }
}
